import { chakra, Text } from '@chakra-ui/react';

export const HighlightableText = chakra(Text, {
  baseStyle: {
    background: 'transparent',
    '&[data-highlighted]': {
      background: 'rgba(0, 0, 0, 0.15)',
      transition: 'background 0.5s ease',
    },
  },
});
